<nav>
  <div ngClass="{{!(proxyMode$ | async) ? 'titlebar-container' : 'titlebar-container proxy-mode-bar' }}">
    <div class="invisible-div">
      <!-- USED FOR POSITIONING THE PROXY MODE TEXT. DO NOT REMOVE -->
    </div>
    @if ((proxyMode$ | async)) {
    <div class="proxy-mode">
      PROXY MODE
    </div>
    }
    <div class="titlebar-right btn-group">
      <div ngbDropdown class="nav-item profile">
        <button type="button" class="nav-link" ngbDropdownToggle>Hello, {{ userName }}</button>
        <ul class="profile-dropdown" ngbDropdownMenu>
          @if (isAdminUser) {
          <li class="p-0">
            <div ngbAccordion class="accordion-flush">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button class="navbar-link" ngbAccordionButton>Admin</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <ul class="list-unstyled">
                        @if (isCategoryUser) {
                        <li>
                          <a class="navbar-link" routerLink="/admin/categorymanagement" ngbDropdownItem>
                            Category Management
                          </a>
                        </li>
                        }
                        @if (isPrivilegeUser) {
                        <li>
                          <a class="navbar-link" routerLink="/admin/privilegemanagement" ngbDropdownItem>
                            Privilege Management
                          </a>
                        </li>
                        }
                        @if (isTagUser) {
                        <li>
                          <a class="navbar-link" routerLink="/admin/tagmanagement" ngbDropdownItem>
                            Tag Management
                          </a>
                        </li>
                        }
                      </ul>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </li>
          }
          <li>
            <a class="navbar-link" routerLink="/notificationverification" ngbDropdownItem>
              Notification verification
            </a>
          </li>
          @if (isReportManagementAccess || isGeneralMgr) {
          <li>
            <a class="navbar-link" routerLink="reporthistory/reportsearch" id="history_search_reports"
              ngbDropdownItem>Report
              Search</a>
          </li>
          }
          @if (isProxyUser && !(proxyMode$ | async)) {
          <li class="proxy">
            <div>Proxy as user: </div>
            <div class="user-search-control">
              <input type="text" placeholder="Enter user id" [(ngModel)]="proxyUserId" (keyup.enter)="loadProxyUser()">
              <button (click)="loadProxyUser()">Go</button>
            </div>
          </li>
          }
          @if ((proxyMode$ | async)) {
          <li><Button ngbDropdownItem class="logout exitProxy" (click)="exitProxyMode()">Exit Proxy
              Mode</Button></li>
          }
          <li>
            <button class="logout" routerLink="/logout" ngbDropdownItem>
              <fa-icon class="profile-icon" [icon]="'sign-out-alt'"></fa-icon>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
